// extracted by mini-css-extract-plugin
export var col = "index-module--col--281bc";